import * as React from 'react';
import { SettingTabPanelList } from '../../common/SettingTabPanelList';
import ShapeKindTabPanelListRow from './ShapeKindTabPanelListRow';
import ObjectFillColorTabPanelListRow from './ObjectFillColorTabPanelListRow';
import ObjectLineWidthTabPanelListRow from './ObjectLineWidthTabPanelListRow';
import ObjectLineTypeTabPanelListRow from './ObjectLineTypeTabPanelListRow';

const borderStyle: React.CSSProperties = {
  width: '100%',
  height: 2,
  backgroundColor: '#bebebe',
  border: 0,
  margin: 0,
};

const ObjectDrawingSettingTabPanel: React.SFC = () => {
  return (
    <SettingTabPanelList style={{ padding: 0 }}>
      <ShapeKindTabPanelListRow />
      <hr style={borderStyle} />
      <ObjectFillColorTabPanelListRow />
      <hr style={borderStyle} />
      <ObjectLineWidthTabPanelListRow />
      <hr style={borderStyle} />
      <ObjectLineTypeTabPanelListRow />
    </SettingTabPanelList>
  );
};

export default ObjectDrawingSettingTabPanel;
